import { Navigate, Route, Routes } from "react-router-dom";
import { AuthPagesThemeProvider } from "./theme/ThemeContext.tsx";
import { LoginScreen } from "./pages/LoginScreen.tsx";
import { SignupScreen } from "./pages/SignupScreen.tsx";
import { ProfileScreen } from "./pages/ProfileScreen.tsx";
import { SendPasswordResetScreen } from "./pages/SendPasswordResetScreen.tsx";
import { ChangePasswordScreen } from "./pages/ChangePasswordScreen.tsx";
import { ResetPasswordScreen } from "./pages/ResetPasswordScreen.tsx";
import { RequireAuth } from "./container/RequireAuth.tsx";
import { AppRedirect } from "./container/AppRedirect.tsx";
import { ProfileVerificationScreen } from "./pages/ProfileVerificationScreen.tsx";
import { AdminDashboard } from "./admin/pages/AdminDashboard.tsx";
import { AdminLayout } from "./admin/container/AdminLayout.tsx";
import { ClientManagement } from "./admin/pages/ClientManagement.tsx";
import { ClientDetailPage } from "./admin/pages/ClientDetailPage.tsx";
import { ApiKeyManagement } from "./admin/pages/ApiKeyManagement.tsx";
import { RoleManagement } from "./admin/pages/RoleManagement.tsx";
import { UserManagement } from "./admin/pages/UserManagement.tsx";
import { UserDetailPage } from "./admin/pages/UserDetailPage.tsx";
import { AppUserEditPage } from "./admin/pages/AppUserEditPage.tsx";
import { InvitationManagement } from "./admin/pages/InvitationManagement.tsx";
import { DataCleanupManagement } from "./admin/pages/DataCleanupManagement.tsx";
import { EmailTestManagement } from "./admin/pages/EmailTestManagement.tsx";
import { SendMessageManagement } from "./admin/pages/SendMessageManagement.tsx";
import { AdminInboxManagement } from "./admin/pages/AdminInboxManagement.tsx";
import { DeletionConfirmationScreen } from "./pages/DeletionConfirmationScreen.tsx";
import { CompleteInviteScreen } from "./pages/CompleteInviteScreen.tsx";
import { InviteExpiredScreen } from "./pages/InviteExpiredScreen.tsx";
import { InviteMismatchScreen } from "./pages/InviteMismatchScreen.tsx";

const AppRoutes = () => {
    return (
            <Routes>
                <Route path="/" element={<Navigate to="/app/login" replace />} />
                <Route path="/app">
                    <Route index element={<AppRedirect />} />
                    <Route path="login" element={<AuthPagesThemeProvider><LoginScreen /></AuthPagesThemeProvider>} />
                    <Route path="signup" element={<AuthPagesThemeProvider><SignupScreen /></AuthPagesThemeProvider>} />
                    <Route path="profile" element={<RequireAuth><ProfileScreen /></RequireAuth>} />
                    <Route path="send-password-reset" element={<AuthPagesThemeProvider><SendPasswordResetScreen /></AuthPagesThemeProvider>} />
                    <Route path="reset-password" element={<ResetPasswordScreen />} />
                    <Route path="change-password" element={<ChangePasswordScreen />} />
                    <Route path="verify-user" element={<ProfileVerificationScreen />} />
                    <Route path="confirm-deletion" element={<DeletionConfirmationScreen />} />
                    <Route path="complete-invite" element={<AuthPagesThemeProvider><CompleteInviteScreen /></AuthPagesThemeProvider>} />
                    <Route path="invite-expired" element={<InviteExpiredScreen />} />
                    <Route path="invite-mismatch" element={<InviteMismatchScreen />} />
                </Route>
                <Route path="/app/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="clients" element={<ClientManagement />} />
                    <Route path="clients/:clientId" element={<ClientDetailPage />} />
                    <Route path="clients/:clientId/app-users/:appUserId" element={<AppUserEditPage />} />
                    <Route path="roles" element={<RoleManagement />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="users/:tid" element={<UserDetailPage />} />
                    <Route path="users/:tid/app-users/:appUserId" element={<AppUserEditPage />} />
                    <Route path="api-keys" element={<ApiKeyManagement />} />
                    <Route path="invitations" element={<InvitationManagement />} />
                    <Route path="data-cleanup" element={<DataCleanupManagement />} />
                    <Route path="messages" element={<SendMessageManagement />} />
                    <Route path="inbox" element={<AdminInboxManagement />} />
                    <Route path="email-test" element={<EmailTestManagement />} />
                </Route>
            </Routes>
    );
};

export default AppRoutes;